import React from 'react';

export const ScheduleIconNew = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_37042_34213)">
        <path d="M11.4737 18.5961H11.436L11.4325 18.5858L11.4737 18.5961Z" fill="#D9ECFA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.436 18.5961H4.72849V9.59217H17.9714V12.0159C18.3015 12.0572 18.6212 12.1294 18.9409 12.2222C19.2607 12.315 19.5598 12.4285 19.8589 12.5625V5.98233C19.8589 5.48727 19.6732 5.0644 19.3019 4.71374C18.9306 4.36307 18.4871 4.18773 17.9611 4.18773H17.0122V3.33168C17.0122 2.80568 16.5894 2.38281 16.0634 2.38281C15.5374 2.38281 15.1145 2.80568 15.1145 3.33168V4.18773H7.54416V3.33168C7.54416 2.80568 7.12129 2.38281 6.59529 2.38281C6.06928 2.38281 5.64642 2.80568 5.64642 3.33168V4.18773H4.69755C4.18186 4.18773 3.72805 4.36307 3.35675 4.71374C2.98545 5.0644 2.7998 5.48727 2.7998 5.98233V18.5961C2.7998 19.0912 2.98545 19.5141 3.35675 19.8647C3.72805 20.2154 4.17154 20.3907 4.69755 20.3907H12.3607C12.1544 20.1226 11.9791 19.8338 11.8244 19.5347C11.6713 19.2387 11.5485 18.9225 11.436 18.5961ZM4.72849 5.98233H17.9714V7.78725H4.72849V5.98233Z"
          fill={className}
        />
        <path
          d="M7.20388 10.8197H6.24469C6.06241 10.8197 5.91465 10.9675 5.91465 11.1498V12.109C5.91465 12.2912 6.06241 12.439 6.24469 12.439H7.20388C7.38615 12.439 7.53392 12.2912 7.53392 12.109V11.1498C7.53392 10.9675 7.38615 10.8197 7.20388 10.8197Z"
          fill={className}
        />
        <path
          d="M7.20388 13.1811H6.24469C6.06241 13.1811 5.91465 13.3288 5.91465 13.5111V14.4703C5.91465 14.6526 6.06241 14.8003 6.24469 14.8003H7.20388C7.38615 14.8003 7.53392 14.6526 7.53392 14.4703V13.5111C7.53392 13.3288 7.38615 13.1811 7.20388 13.1811Z"
          fill={className}
        />
        <path
          d="M6.24469 15.543H7.20388C7.38615 15.543 7.53392 15.6907 7.53392 15.873V16.8322C7.53392 17.0145 7.38615 17.1622 7.20388 17.1622H6.24469C6.06241 17.1622 5.91465 17.0145 5.91465 16.8322V15.873C5.91465 15.6907 6.06241 15.543 6.24469 15.543Z"
          fill={className}
        />
        <path
          d="M9.55546 10.8197H8.59628C8.414 10.8197 8.26624 10.9675 8.26624 11.1498V12.109C8.26624 12.2912 8.414 12.439 8.59628 12.439H9.55546C9.73774 12.439 9.8855 12.2912 9.8855 12.109V11.1498C9.8855 10.9675 9.73774 10.8197 9.55546 10.8197Z"
          fill={className}
        />
        <path
          d="M8.59628 13.1811H9.55546C9.73774 13.1811 9.8855 13.3288 9.8855 13.5111V14.4703C9.8855 14.6526 9.73774 14.8003 9.55546 14.8003H8.59628C8.414 14.8003 8.26624 14.6526 8.26624 14.4703V13.5111C8.26624 13.3288 8.414 13.1811 8.59628 13.1811Z"
          fill={className}
        />
        <path
          d="M9.55546 15.543H8.59628C8.414 15.543 8.26624 15.6907 8.26624 15.873V16.8322C8.26624 17.0145 8.414 17.1622 8.59628 17.1622H9.55546C9.73774 17.1622 9.8855 17.0145 9.8855 16.8322V15.873C9.8855 15.6907 9.73774 15.543 9.55546 15.543Z"
          fill={className}
        />
        <path
          d="M10.9377 10.8197H11.8969C12.0791 10.8197 12.2269 10.9675 12.2269 11.1498V12.109C12.2269 12.2912 12.0791 12.439 11.8969 12.439H10.9377C10.7554 12.439 10.6076 12.2912 10.6076 12.109V11.1498C10.6076 10.9675 10.7554 10.8197 10.9377 10.8197Z"
          fill={className}
        />
        <path
          d="M11.8969 13.1811H10.9377C10.7554 13.1811 10.6076 13.3288 10.6076 13.5111V14.4703C10.6076 14.6526 10.7554 14.8003 10.9377 14.8003H11.8969C12.0791 14.8003 12.2269 14.6526 12.2269 14.4703V13.5111C12.2269 13.3288 12.0791 13.1811 11.8969 13.1811Z"
          fill={className}
        />
        <path
          d="M13.2787 10.8197H14.2379C14.4202 10.8197 14.568 10.9675 14.568 11.1498V12.109C14.568 12.2912 14.4202 12.439 14.2379 12.439H13.2787C13.0964 12.439 12.9487 12.2912 12.9487 12.109V11.1498C12.9487 10.9675 13.0964 10.8197 13.2787 10.8197Z"
          fill={className}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.4951 17.2657C12.4951 14.8626 14.4444 12.9133 16.8475 12.9133C19.2506 12.9133 21.2 14.8626 21.2 17.2657C21.2 19.6688 19.2506 21.6181 16.8475 21.6181C14.4444 21.6181 12.4951 19.6688 12.4951 17.2657ZM18.2708 19.4522C18.2708 19.4522 18.6421 19.741 18.9515 19.4316H18.9619C19.261 19.1222 18.9928 18.7715 18.9928 18.7715L17.4045 17.2657V14.8832C17.4045 14.8832 17.3323 14.4707 16.8991 14.4707C16.4659 14.4707 16.3834 14.8832 16.3834 14.8832V17.6576L18.2708 19.4522Z"
          fill={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_37042_34213">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
